import React from 'react'
import classes from './Teams.module.css'
import { Card } from 'react-bootstrap'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import userLogoAlt from '../../../Content/images/userFallbackAltImg.svg';
import NotAvailable from '../NotAvailable';

const Teams = ({teams=[]}) => {
    const TeamCard=({team,key})=>{
        
        return <Card className={classes['ContactCard']}>
             <div className={classes['Body']}>
             <div className={classes['LeftCol']}>
                    
                    <img alt='img' src={userLogoAlt} className={classes['LogoImg']}/>
            </div>
            <div className={classes['RightCol']}>
                <div className={classes['PersonName']}>
                    {team.name}
                </div>
                <div className={classes['Designation']}>
                    {team.designation}
                </div>

            </div>
             </div>
            

        </Card>
    }
    return (
        <div className={classes['Container']}>
            <SubSectionHeader title="Management Team" className={classes['title']}></SubSectionHeader>
            <div className={classes['Master']}>
            {
              teams.length>0?  
              <div className={classes['CardContainer']}>

             { 
             teams.map((item,index)=><TeamCard team={item} key={index}/>)
             } 
             </div>

              :<NotAvailable/>
            }
            </div>
            
        </div>
    )
}


export default Teams
